<section class="section-filter-items" #container>
  <div class="section-filter-items__buttons-wrapper">
    @if (data().showCategoryFilter) {
      <div class="section-filter-items__button-list" role="tablist">
        <a
          class="section-filter-items__button"
          role="tab"
          [routerLink]="['.']"
          [class.section-filter-items__button--active]="fetchParams().categoryFilter.length === 0"
          >{{ 'SectionFilterItems.OptionAll' | translate }}</a
        >
        @for (cat of categories(); track cat.id) {
          <a
            role="tab"
            class="section-filter-items__button"
            [routerLink]="['.']"
            [queryParams]="getQueryParam(cat)"
            [paiTrackEvent]="{ event: filterEventName(), value: { filterCategory: cat.slug } }"
            [class.section-filter-items__button--active]="fetchParams().categoryFilter.includes(cat.id)"
          >
            <span>{{ cat.label }}</span>
          </a>
        }
      </div>
    }
  </div>

  @let value = cards.value();

  @if (value) {
    <div class="section-filter-items__grid">
      @switch (value.type) {
        @case ('projects') {
          @for (card of value?.cards; track card.id) {
            <pai-project-item-card [project]="card" />
          }
        }
        @case ('publications') {
          @for (card of value?.cards; track card.id) {
            <pai-publication-item-card [data]="card" />
          }
        }
      }
    </div>
    @if (value.totalPages > 1 && data().showPagination) {
      <div class="section-filter-items__pagination">
        <pai-pagination [pageCount]="value.totalPages" />
      </div>
    }
  }
</section>
